import request from '@/utils/request'

/**
 * 新增地图点位数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistAdd(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/add',
    method: 'post',
    data
  })
}

/**
 * 删除地图点位数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistDelete(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/delete',
    method: 'post',
    data
  })
}

/**
 * 获取地图点位数据字典详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/get',
    method: 'post',
    data
  })
}

/**
 * 地图点位数据字典列表(不分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/list/get',
    method: 'post',
    data
  })
}

/**
 * 地图点位数据字典列表(不分页)(微信端)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistListNotokenGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/list/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 地图点位数据字典列表(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistPageListGet(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/page/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改地图点位数据字典
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function mapAnchorDistUpdate(data) {
  return request({
    type: 'biz',
    url: 'map/anchor/dist/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/MapAnchorDict.js